/**
 * [important] 请添加支持组件的类型的同时， 指定组件引入 和 对应组件默认状态值
 */

import CheckboxCustom from "./CheckboxCustom";
import SelectCustom from "./SelectCustom";
import SelectgroupCustom from "./SelectgroupCustom/";
import SelectremotefilterCustom from "./SelectRemoteFilterCustom";
import RadioCustom from "./RadioCustom";
import RadiobuttonCustom from "./RadioButtonCustom";
import DatepickerCustom from "./DatepickerCustom";
import InputCustom from "./InputCustom";
import LabelCustom from "./LabelCustom";
import SwitchCustom from "./SwitchCustom";
import DatewmqyCustom from "./DatewmqyCustom/";
import CoverselectCustom from "./CoverselectCustom/";
import AdvanceDefaultQuerySwtich from "./AdvanceDefaultQuerySwtich";
import AutocompleteCustom from "./AutoCompleteCustom";
import UploadCustom from "./UploadCustom";
import DownloadtemplateCustom from "./DownloadTemplateCustom";
import RadioinputCustom from "./RadioInputCustom";

import CascaderCustom from "./CascaderCustom";
import InputrangeCustom from "./InputRange";
import UploadfileCustom from "./UploadFileCustom";
import AddressCustom from "./AddressCustom";

import TreeCustom from "./TreeCustom";

// 定义支持的类型
export const SUPPORT_TYPE = [
  "checkbox",
  "select",
  "selectgroup",
  "selectremotefilter",
  "radio",
  "radiobutton",
  "input",
  "label",
  "datepicker",
  "switch",
  "datewmqy",
  "coverselect",
  "advance",
  "autocomplete",
  "upload",
  "downloadtemplate",
  "cascader",
  "inputrange",
  "radioinput",
  "uploadfile",
  "tree",
  "address"
];

// 支持的类型对应的组件
export const components = {
  CheckboxCustom,
  SelectCustom,
  SelectgroupCustom,
  SelectremotefilterCustom,
  RadioCustom,
  RadiobuttonCustom,
  DatepickerCustom,
  InputCustom,
  LabelCustom,
  SwitchCustom,
  DatewmqyCustom,
  CoverselectCustom,
  AdvanceDefaultQuerySwtich,
  AutocompleteCustom,
  UploadCustom,
  DownloadtemplateCustom,
  CascaderCustom,
  InputrangeCustom,
  RadioinputCustom,
  UploadfileCustom,
  TreeCustom,
  AddressCustom
};

// 支持的类型对应的默认值
export function getDefaultValue({ mold, multiple, type, default: def }) {
  switch (mold) {
    case "coverselect":
      return {
        value: isEmpty(def)
          ? multiple
            ? [...def]
            : def
          : multiple
            ? []
            : null
      };
      break;

    case "select":
      return {
        value: isEmpty(def) ? [...def] : []
      };
      break;

    case "selectgroup":
      return {
        value: isEmpty(def) ? [...def] : []
      };
      break;

    case "selectremotefilter":
      return {
        value: isEmpty(def)
          ? multiple
            ? [...def]
            : def
          : multiple
            ? []
            : null
      };
      break;

    case "input":
      return {
        value: isEmpty(def) ? def : ""
      };

    case "label":
      return {
        value: isEmpty(def) ? def : ""
      };

    case "upload":
      return {
        value: isEmpty(def)
          ? multiple
            ? [...def]
            : def
          : multiple
            ? []
            : null
      };

    case "downloadtemplate":
      return {
        value: null
      };

    case "checkbox":
      return {
        value: isEmpty(def) ? [...def] : []
      };

    case "radio":
      return {
        value: isEmpty(def) ? def : null
      };

    case "radiobutton":
      return {
        value: isEmpty(def) ? def : null
      };

    case "datepicker":
      return {
        value: isEmpty(def) ? def : null
      };

    case "datewmqy":
      return {
        value: type.includes("range")
          ? isEmpty(def) ? [...def] : []
          : isEmpty(def) ? def : null
      };

    case "switch":
      return {
        value: isEmpty(def) ? def : false
      };

    case "autocomplete":
      return {
        value: def ? def : null
      };

    case "querybutton":
      return null;

    case "addbutton":
      return null;

    case "otherbutton":
      return null;

    case "advance":
      return {
        value: def ? def : false
      };

    case "cascader":
      return {
        value: isEmpty(def) ? [...def] : []
      };
    case "uploadfile":
      return {
        value: null
      };
    case "inputrange":
      return {
        value: def ? def : {
          max: "",
          min: ""
        }
      };
    case "radioinput":
      return {
        value: isEmpty(def) ? { ...def } : {}
      };
    case "tree":
      return {
        value: isEmpty(def) ? [...def] : []
      };
    case "address":
      return {
        value: isEmpty(def) ? [...def] : []
      };
    default:
      alert(`未匹配到符合该类型${mold}的功能,请联系开发人员`);
      return null;
  }
}

export function isEmpty(def) {
  return def !== null && def !== undefined;
}

export function isFunc(callBack) {
  return callBack && typeof callBack === "function";
}

